import { type Permission } from '~/domain/users/models/permission.ts';

import NavbarLink from './navbar-link';

interface Props {
  userPermissions?: Permission[];
  userGymIds?: string[];
  athleteProfileId?: string;
}

const findGymsLink = { label: 'Find Gyms & Classes', route: '/gym' };
const findEventsLink = { label: 'Find Events', route: '/events' };
const myGymLink = { label: 'My Gym', route: '/admin/gyms' };

export function NavbarLinks({ userPermissions, userGymIds, athleteProfileId }: Props) {
  const userLinks = [];
  const myProfileLink = { label: 'My Profile', route: `/a/${athleteProfileId}` };
  if (userPermissions?.includes('GymList')) {
    myGymLink.route = userGymIds?.length === 1 ? `/admin/gyms/${userGymIds[0]}` : '/admin/gyms';
    userLinks.push(myGymLink);
  }

  userLinks.push(myProfileLink);
  userLinks.push(findGymsLink);
  userLinks.push(findEventsLink);

  const links = userLinks.map((link) => <NavbarLink key={link.label} {...link} />);

  return <div className="flex flex-row">{links}</div>;
}
